import { getBeginLocalStr, getBeginStr, getEndLocalStr, getEndStr } from "../../core/utils/date-utils";

// Sunucudaki ReAssessmentDateType ile birebir.
export const RE_ASSESSMENT_DATE_TYPE = {
    REQUEST: 0,
    RESOLVE: 1,
    STUDY: 2,
}

/**
 * TEK KAYNAK: grid, sayaç ve istatistik AYNI normalizasyondan geçer — aksi halde üç taraf farklı
 * tarih aralığı sorgular (bkz. rapor ekranındaki aynı hata).
 *
 * Çekim tarihi sunucuda duvar saati olarak tutuluyor, UTC'ye kaydırılmaz; talep/kapanış tarihleri UTC.
 */
export const normalizeReAssessmentFilter = (filter) => {
    const isLocal = filter?.dateType === RE_ASSESSMENT_DATE_TYPE.STUDY;

    return {
        ...filter,
        dateBegin: isLocal ? getBeginLocalStr(filter?.dateBegin) : getBeginStr(filter?.dateBegin),
        dateEnd: isLocal ? getEndLocalStr(filter?.dateEnd) : getEndStr(filter?.dateEnd),
    };
}

export const toReAssessmentQuery = (queryModel) => ({
    ...queryModel,
    filter: normalizeReAssessmentFilter(queryModel?.filter),
});
